module.exports = __webpack_public_path__ + "static/media/flask-poison.88b8abeb.svg";